/* eslint-disable */
import toast from '../../services/toast';
import { mapGetters } from 'vuex';
var $ = window.jQuery = require('jquery');
import axios from 'axios';
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'
Vue.use(Viewer)
export default {
  name: 'img-list-for-quiz',
  components: {},
  props: [],
  data () {
    return {
      title:'',
      description:'',
      file: null,
      name: '',
      uploadFileName:'',
      quizImagesDetails:'',
      quizImagesDetailsResults: {},
      imgViewer:false,
      viewerImg:'',
      copyImgUrl:'',
      nextStep: '',
      loadmoreData: {},
      userLoading: false,
    }
  },
  computed: {
    ...mapGetters([
      'getImgforQuizDataState'
    ]),
    getQuizImgdetails() {
      return this.quizImagesDetails = this.$store.getters.getImgforQuizDataState.data
    },
    SetIntialStatus() {
      if (this.quizImagesDetails != undefined) {
        this.nextStep = this.quizImagesDetails.next
        this.quizImagesDetailsResults = this.quizImagesDetails.results
      }
    }
  },
  mounted () {
    $('.not_copied_text').addClass("d-none")
    this.getQuizImgdetails
    this.SetIntialStatus 
    let self = this;
    window.addEventListener('keyup', function(event) {
        // If  ESC key was pressed...
        if (event.keyCode === 27) {
            self.imgViewer = false;
            $('body').removeClass("img_view_actv")
        }
    });
		$(document).ready(function (argument) {
			$(document).click(function(event) {
			  //if you click on anything except the modal itself or the "open modal" link, close the modal
			  if (!$(event.target).closest(".imgurl_copypopup, .not_copied_text").length) {
				 $('.not_copied_text').addClass('d-none');
			  }
      });
    });
  },
  methods: {
    loadmoreUser(url) {
      this.userLoading = true
      axios.get(url)
        .then((response) => {
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          this.$set(this.quizImagesDetails, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.quizImagesDetailsResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
    handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.filesSize = this.$refs.file.files[0].size;
        this.uploadFileName = this.files.name
        let title = this.uploadFileName.split('.')
        this.title = title[0]
      } else {
        this.uploadFileName = '';
      }
    },
    getImgList(){
      this.$store.dispatch('getImgforQuizFun').then((res) => {

      })
    },
    creatImageConfirmation(e) {
       this.$validator.validateAll().then((result) => {
         this.submitted = true;
         if (result) {
          let formData = new FormData();
          formData.append('image', this.file);
          formData.append('title', this.title);
          formData.append('description', this.description);
           this.$store.dispatch('createImgforQuizFun', formData)
             .then((res) => {
                this.title = '',
                this.description = '',
                this.uploadFileName = '',
                this.file = null,
               this.$validator.reset();
               this.getImgList()
               toast.success(res.data.msg);
             })
             .catch((err) => { })
           return
         }
       });
     },
     imgViewerFun(url){
       this.viewerImg = url
       this.imgViewer = true
       $('body').addClass("img_view_actv")
     },
     imgViewerCloseFun(){
      this.imgViewer = false
      $('body').removeClass("img_view_actv")
     },
     imgViewerCopyFun(ImgUrl, index){ 
      var clipboard = navigator.clipboard;
      if (clipboard == undefined) {
        $('.not_copied_text').addClass("d-none")
        $('.NotCopiedUrl' + index).removeClass("d-none")
        setTimeout(() => {
          $('.NotCopiedUrl' + index).addClass("d-none")
        },90000)
          console.log('clipboard is undefined');
      } else {
        clipboard.writeText(ImgUrl).then(() => {
        $('.CopiedUrl' + index).removeClass("d-none")
        setTimeout(() => {
          $('.CopiedUrl' + index).addClass("d-none")
        }, 500)
        console.log('clipboard Success');
        },() => {
          $('.NotCopiedUrl' + index).removeClass("d-none")
          setTimeout(() => {
            $('.NotCopiedUrl' + index).addClass("d-none")
          },2000)
          console.log('clipboard Error');
        })
      }
     },
  },
  watch: {
    getQuizImgdetails() {
      return this.$store.getters.getImgforQuizDataState
    },
    SetIntialStatus() {
      if (this.quizImagesDetails != undefined) {
        this.quizImagesDetailsResults = this.quizImagesDetails.results
      }
    }
  },
}